import React from 'react';
import { AeBreadcrumbs, type AeBreadcrumbItem } from '../AeBreadcrumbs';

interface AePageHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  breadcrumbs?: AeBreadcrumbItem[];
}

/** Page title block — title above fields, compact subtitle, optional actions row. */
export const AePageHeader: React.FC<AePageHeaderProps> = ({
  title,
  description,
  actions,
  breadcrumbs,
}) => (
  <header className="mb-6">
    {breadcrumbs && breadcrumbs.length > 0 && <AeBreadcrumbs items={breadcrumbs} />}
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <h1 className="text-xl font-bold text-[var(--color-surface-text)]">{title}</h1>
        {description && (
          <p className="mt-0.5 text-xs text-[var(--color-secondary-text)]">{description}</p>
        )}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  </header>
);
